/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopRatingPhaseCategoryWeight'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./WorkshopRatingPhaseCategoryWeight'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopRatingPhaseSourceReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopRatingPhaseCategoryWeight);
  }
}(this, function(ApiClient, WorkshopRatingPhaseCategoryWeight) {
  'use strict';




  /**
   * The WorkshopRatingPhaseSourceReport model module.
   * @module model/WorkshopRatingPhaseSourceReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopRatingPhaseSourceReport</code>.
   * @alias module:model/WorkshopRatingPhaseSourceReport
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>WorkshopRatingPhaseSourceReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopRatingPhaseSourceReport} obj Optional instance to populate.
   * @return {module:model/WorkshopRatingPhaseSourceReport} The populated <code>WorkshopRatingPhaseSourceReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CategoryWeights')) {
        obj['CategoryWeights'] = ApiClient.convertToType(data['CategoryWeights'], [WorkshopRatingPhaseCategoryWeight]);
      }
      if (data.hasOwnProperty('WeightedLevelID')) {
        obj['WeightedLevelID'] = ApiClient.convertToType(data['WeightedLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('ItemWeight')) {
        obj['ItemWeight'] = ApiClient.convertToType(data['ItemWeight'], 'Integer');
      }
      if (data.hasOwnProperty('RatedItemCount')) {
        obj['RatedItemCount'] = ApiClient.convertToType(data['RatedItemCount'], 'Integer');
      }
      if (data.hasOwnProperty('WidgetID')) {
        obj['WidgetID'] = ApiClient.convertToType(data['WidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('RatedWidgetID')) {
        obj['RatedWidgetID'] = ApiClient.convertToType(data['RatedWidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/WorkshopRatingPhaseCategoryWeight>} CategoryWeights
   */
  exports.prototype['CategoryWeights'] = undefined;
  /**
   * @member {Integer} WeightedLevelID
   * @default 0
   */
  exports.prototype['WeightedLevelID'] = 0;
  /**
   * @member {Integer} ItemWeight
   * @default 0
   */
  exports.prototype['ItemWeight'] = 0;
  /**
   * @member {Integer} RatedItemCount
   */
  exports.prototype['RatedItemCount'] = undefined;
  /**
   * @member {Integer} WidgetID
   * @default 0
   */
  exports.prototype['WidgetID'] = 0;
  /**
   * @member {Integer} RatedWidgetID
   * @default 0
   */
  exports.prototype['RatedWidgetID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


